import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Skeleton } from '@mui/material';
import { paperTradingApi, PaperTrade } from '../../../services/paperTradingApi';

const ActivityFeed: React.FC = () => {
  const [trades, setTrades] = useState<PaperTrade[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    paperTradingApi.getTrades(10)
      .then(setTrades)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={150} />
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} variant="rectangular" height={50} sx={{ mt: 1, borderRadius: 1 }} />
          ))}
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>Letzte Aktivitäten</Typography>

        {trades.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography variant="body2" color="text.secondary">Noch keine Trades</Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {trades.slice(0, 5).map((t) => {
              const isBuy = t.side === 'buy';
              const [base] = t.market.split('-');
              const timeStr = t.created_at
                ? new Date(t.created_at).toLocaleString('de-DE', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit' })
                : '';

              const costBasis = t.total - t.realized_pnl - t.fee;
              const pnlPct = !isBuy && costBasis > 0 ? (t.realized_pnl / costBasis) * 100 : 0;
              const pnlPositive = t.realized_pnl >= 0;
              const pnlSign = pnlPositive ? '+' : '';

              return (
                <Box
                  key={t.id}
                  sx={{
                    p: 1, borderRadius: 1.5,
                    bgcolor: isBuy ? 'success.main' : 'error.main',
                    backgroundColor: isBuy ? 'rgba(76, 175, 80, 0.08)' : 'rgba(239, 83, 80, 0.08)',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" sx={{ color: isBuy ? 'success.main' : 'error.main' }} fontWeight={600}>
                      {isBuy ? '↗' : '↘'} {isBuy ? 'Kauf' : 'Verkauf'} {t.amount.toFixed(6)} {base}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">{timeStr}</Typography>
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    €{t.total.toFixed(2)} · Gebühr: €{t.fee.toFixed(2)}
                  </Typography>
                  {!isBuy && (
                    <Typography
                      variant="caption"
                      sx={{ display: 'block', fontWeight: 600, color: pnlPositive ? 'success.main' : 'error.main' }}
                    >
                      Realisierter G/V: {pnlSign}€{t.realized_pnl.toFixed(2)} ({pnlSign}{pnlPct.toFixed(2)}%)
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;
